export default {
    state: {
        filters: {},
    },
    mutations: {
        setFilters(state, filters) {
            state.filters = filters;
        },
        
    },
    actions: {
        setFilters({commit}, filters) {
            commit('setFilters', filters);
        },
    },
};